/**
 * Total pages of data in the provided dataset
 *
 * @param  {Object} state
 * @return {Number}
 */
const totalPages = state => {
    let rows = state.data.table_data.meta.number_of_rows + 1
    let limit = state.pagination.pageLimit

    return Math.ceil(rows / limit)
}

/**
 * Get the offset for the dataset
 *
 * @return {Number}
 */
const offset = state => (state.pagination.currentPage - 1) * state.pagination.pageLimit

/**
 * Paginated Dataset
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
const paginatedDataset = (state, getters) => {
    return state.data.table_data.data.map(row => {
        return {
            format: row.format,
            is_calculated_total: row.is_calculated_total,
            our_label: row.our_label,
            their_label: row.their_label,
            data: row.data.slice(getters.offset, (state.pagination.pageLimit * state.pagination.currentPage))
        }
    })
}

export default {
    offset,
    totalPages,
    paginatedDataset
}



// WEBPACK FOOTER //
// ./src/state/modules/rent-roll-importer/getters.js